import StressData from "../GarminCards/StressData";
import CaloriesData from "../GarminCards/CaloriesData";
import BatteryData from "../GarminCards/BatteryData";
import HRVData from "../GarminCards/HRVData";
import SleepData from "../GarminCards/SleepData";
import StepData from "../GarminCards/StepData";

export default function Activities({ patientDetails }) {
  return (
    <div className="mt-3 h-80 scrollHide overflow-y-scroll">
      <div className="grid grid-cols-2 gap-1 px-1">
        {/* <div className="p-1">
          <div className="w-full h-44 bg-white rounded-lg shadow flex flex-col justify-center items-center p-4">
            <div className="flex items-center gap-2 self-start">
              <img src={Stress} alt="icon" />
              <h2 className="text-sm font-sans font-semibold">Stress</h2>
            </div>
            <div className="relative w-36 h-36">
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={stressData}
                    dataKey="value"
                    innerRadius={45}
                    outerRadius={55}
                    startAngle={90}
                    endAngle={-270}
                  >
                    {stressData.map((entry, i) => (
                      <Cell key={i} fill={entry.color} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div className="absolute inset-0 flex items-center justify-center text-lg font-sans font-semibold">
                {stressValue}
              </div>
            </div>
          </div>
        </div> */}
        <div className="my-1">
          {" "}
          <StressData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
        {/* Sleep */}
        {/* <div className="p-1 ">
          <div className="bg-white shadow rounded-lg p-4 w-full h-44 overflow-y-auto scrollHide">
            <div className="flex items-center gap-2 self-start mb-4">
              <img src={Sleep} alt="icon" />
              <h2 className="text-sm font-sans font-semibold">Sleep</h2>
            </div>
            <div className="mt-5 text-sm grid grid-cols-2">
              <div>
                <p className="flex items-center gap-1 font-sans font-semibold">
                  <IoAlarmOutline /> 7h 30m
                </p>
                <p className="text-gray-500 text-xs">Duration</p>
              </div>
              <div>
                <p className="flex items-center gap-1 font-sans font-semibold">
                  <LuBedDouble /> 11:00 PM
                </p>
                <p className="text-gray-500 text-xs">Bed time</p>
              </div>
              <div className="mt-4">
                <p className="flex items-center gap-1 font-sans font-semibold">
                  <PiTimer /> 06:30 AM
                </p>
                <p className="text-gray-500 text-xs">Wake time</p>
              </div>
            </div>
          </div>
        </div> */}
        <div className="my-1">
          {" "}
          <SleepData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
        {/* Steps */}
        {/* <div className="p-1">
          <div className="bg-white shadow rounded-lg p-4 full h-44">
            <div className="flex items-center gap-2 text-sm font-sans font-semibold">
              <RiFootprintFill className="text-orange-500 w-5 h-5" />
              <span>Steps</span>
            </div>
            <div className="flex justify-center items-center gap-3 mt-4">
              <div className="relative w-20 h-20">
                <svg className="w-full h-full" viewBox="0 0 36 36">
                  <path
                    className="stroke-gray-200"
                    strokeWidth="3"
                    fill="none"
                    d="M18 2.0845a15.9155 15.9155 0 1 1 0 31.831 15.9155 15.9155 0 1 1 0-31.831"
                  />
                  <path
                    className="stroke-blue-500"
                    strokeWidth="3"
                    strokeDasharray={`${(steps / stepsGoal) * 100}, 100`}
                    strokeLinecap="round"
                    fill="none"
                    d="M18 2.0845a15.9155 15.9155 0 1 1 0 31.831 15.9155 15.9155 0 1 1 0-31.831"
                  />
                </svg>
                <span className="absolute inset-0 flex items-center justify-center text-sm font-semibold">
                  {steps}
                </span>
              </div>
              <p className="text-xs text-center mt-2">{stepsGoal}</p>
            </div>
          </div>
        </div> */}
        <div className="my-1">
          {" "}
          <StepData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
        {/* Calories Burned */}
        {/* <div className="p-1">
          <div className="bg-white shadow rounded-lg p-4 full h-44">
            <div className="flex items-center gap-2 text-sm font-sans font-semibold mb-4">
              <RiFireFill className="text-green-500 w-5 h-5" />
              <span>Calories Burned</span>
            </div>
            <div className="text-lg font-semibold mb-4">{totalCalories}</div>
            <div className="w-full h-3 bg-gray-200 rounded-full flex overflow-hidden mb-2">
              <div
                className="bg-red-500"
                style={{ width: `${activePercent}%` }}
              ></div>
              <div
                className="bg-blue-500"
                style={{ width: `${restingPercent}%` }}
              ></div>
            </div>
            <div className="flex justify-between text-sm mt-1">
              <div className="flex flex-col items-start">
                <span className="font-semibold">{active}</span>
                <span className="text-gray-500 text-xs">Active</span>
              </div>
              <div className="flex flex-col items-end">
                <span className="font-semibold">{resting}</span>
                <span className="text-gray-500 text-xs">Resting</span>
              </div>
            </div>
          </div>
        </div> */}
        <div className="my-1">
          {" "}
          <CaloriesData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
        {/* Body Battery */}
        {/* <div className="p-1">
          <div className="bg-white shadow rounded-lg p-4 w-full h-44">
            <div className="flex items-center gap-2 self-start mb-4">
              <img src={Body} alt="icon" />
              <h2 className="text-sm font-sans font-semibold">Body Battery</h2>
            </div>
            <div className="flex justify-center mt-4">
              <div className="relative w-20 h-20">
                <svg className="w-full h-full" viewBox="0 0 36 36">
                  <path
                    className="stroke-gray-200"
                    strokeWidth="3"
                    fill="none"
                    d="M18 2.0845a15.9155 15.9155 0 1 1 0 31.831 15.9155 15.9155 0 1 1 0-31.831"
                  />
                  <path
                    className="stroke-blue-500"
                    strokeWidth="3"
                    strokeDasharray={`${bodyBattery}, 100`}
                    strokeLinecap="round"
                    fill="none"
                    d="M18 2.0845a15.9155 15.9155 0 1 1 0 31.831 15.9155 15.9155 0 1 1 0-31.831"
                  />
                </svg>
                <span className="absolute inset-0 flex items-center justify-center text-lg font-semibold">
                  {bodyBattery}
                </span>
              </div>
            </div>
          </div>
        </div> */}
        <div className="my-1">
          <BatteryData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
        {/* HRV */}
        {/* <div className="p-1">
          <div className="bg-white shadow rounded-lg p-4 w-full h-44">
            <div className="flex items-center gap-2 self-start mb-4">
              <img src={HRV} alt="icon" />
              <h2 className="text-sm font-sans font-semibold">HRV Status</h2>
            </div>
            <div className="flex justify-between mt-3 text-sm">
              <p className="font-semibold">
                {watchData.restingHeartRateInBeatsPerMinute ?? "-"} ms{" "}
                <span className="text-gray-500 text-xs">Resting</span>
              </p>
              <p className="font-semibold">
                {watchData.maxHeartRateInBeatsPerMinute ?? "-"} ms{" "}
                <span className="text-gray-500 text-xs">Max</span>
              </p>
            </div>
            <div className="mt-2 h-20">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={hrvData}>
                  <CartesianGrid stroke="transparent" />
                  <XAxis dataKey="time" hide />
                  <YAxis hide />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="value"
                    stroke="#ef4444"
                    strokeWidth={2}
                    dot={false}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div> */}
        <div className="my-1">
          <HRVData smartWatchId={patientDetails?.smartWatchUserId} />
        </div>
      </div>
    </div>
  );
}
